import { useEffect } from 'react'

import { Page } from './Page'
import {
  BrandingThemeType,
  Config,
  Screen,
  changeThemeEvent,
  setDocBackgroundColor,
  setDocFont,
  setDocIcon,
  setDocTitle,
  setLoaderIndicatorColor,
} from './utils'

interface Props {
  inDevice: boolean
  language: string
  setLanguage: React.Dispatch<React.SetStateAction<string>>
  theme: BrandingThemeType
  setTheme: React.Dispatch<React.SetStateAction<BrandingThemeType>>
  desktopMode: boolean
  wideDesktopMode: boolean
  config: Config
  email?: string
  token?: string
}

export const App: React.FC<Props> = ({
  inDevice,
  language,
  setLanguage,
  theme,
  setTheme,
  desktopMode,
  wideDesktopMode,
  config,
  email,
  token,
}) => {
  const {
    localization: { languages = [], primaryLanguage },
    branding: {
      appName,
      icons: { iosIcon },
      colorStyles,
      typography: { iosDefaultFontFamily: fontFamily },
    },
    resources = [],
    screens = [],
  } = config
  const applicationName = appName.locales[language]
  const applicationIcon = resources.find(el => el.id === iosIcon)
  const launchScreen = screens.find(el => el.screenName === 'Launch Screen') as Screen

  useEffect(() => {
    if (applicationIcon) {
      setDocIcon(applicationIcon.url)
    }
    setDocFont(fontFamily)
    if (email || token) {
      config.tabBars = []
    }
    if (!languages.includes(language)) {
      setLanguage(primaryLanguage)
    }
    const detectThemeChangeEvent = (e: any) => setTheme(e.detail ? BrandingThemeType.dark : BrandingThemeType.light)
    document.addEventListener(changeThemeEvent, detectThemeChangeEvent)
    return () => {
      document.removeEventListener(changeThemeEvent, detectThemeChangeEvent)
    }
  }, [])

  useEffect(() => {
    if (applicationName) {
      setDocTitle(applicationName)
    }
  }, [applicationName])

  useEffect(() => {
    setLoaderIndicatorColor(colorStyles.primary[theme])
    setDocBackgroundColor(colorStyles.inverseOnSurface[theme])
  }, [theme])

  return (
    <Page
      inDevice={inDevice}
      language={language}
      theme={theme}
      desktopMode={desktopMode}
      wideDesktopMode={wideDesktopMode}
      config={config}
      screens={screens}
      launchScreen={launchScreen}
      email={email}
      token={token}
    />
  )
}
